// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._IGTC2 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
}

.xo9aPg {
  display: flex;
  gap: var(--spacing-2);
  width: 100%;
}

.LCmv4H {
  position: relative;
  width: 100%;
  height: 36px;
}

.zfuHCR {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  transform: translateY(-50%);
  background: var(--surface-neutral-subtle);
  border-radius: 2px;
}

.r1iwnA {
  position: absolute;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: var(--surface-primary-medium);
  border-radius: 2px;
}

.WtGKTj {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 100%;
  margin: 0;
  background: none;
  pointer-events: none;
  -webkit-appearance: none;
  appearance: none;
  touch-action: none;
}

.WtGKTj::-webkit-slider-thumb {
  pointer-events: auto;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--surface-neutral-subtle);
  margin-top: calc((20px - 2px) / -2);
}

.WtGKTj::-moz-range-thumb {
  pointer-events: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--surface-neutral-subtle);
}

.WtGKTj::-ms-thumb {
  pointer-events: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--surface-neutral-subtle);
}

.WtGKTj::-webkit-slider-runnable-track {
  height: 2px;
  background: transparent;
}

.WtGKTj::-moz-range-track {
  height: 2px;
  background: var(--surface-neutral-subtle);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/RangeInput/RangeInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.inputsRow {\n  display: flex;\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.rangeContainer {\n  position: relative;\n  width: 100%;\n  height: 36px;\n}\n\n.sliderTrack {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 2px;\n  transform: translateY(-50%);\n  background: var(--surface-neutral-subtle);\n  border-radius: 2px;\n}\n\n.sliderRange {\n  position: absolute;\n  top: 50%;\n  height: 2px;\n  transform: translateY(-50%);\n  background: var(--surface-primary-medium);\n  border-radius: 2px;\n}\n\n.rangeInput {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 20px;\n  width: 100%;\n  margin: 0;\n  background: none;\n  pointer-events: none;\n  -webkit-appearance: none;\n  appearance: none;\n  touch-action: none;\n}\n\n.rangeInput::-webkit-slider-thumb {\n  pointer-events: auto;\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--surface-neutral-subtle);\n  margin-top: calc((20px - 2px) / -2);\n}\n\n.rangeInput::-moz-range-thumb {\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--surface-neutral-subtle);\n}\n\n.rangeInput::-ms-thumb {\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--surface-neutral-subtle);\n}\n\n.rangeInput::-webkit-slider-runnable-track {\n  height: 2px;\n  background: transparent;\n}\n\n.rangeInput::-moz-range-track {\n  height: 2px;\n  background: var(--surface-neutral-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_IGTC2`,
	"inputsRow": `xo9aPg`,
	"rangeContainer": `LCmv4H`,
	"sliderTrack": `zfuHCR`,
	"sliderRange": `r1iwnA`,
	"rangeInput": `WtGKTj`
};
module.exports = ___CSS_LOADER_EXPORT___;
